import React from 'react';
import { Typography } from "../../../components/Typography/Typography";
import { useTranslation } from "../../../hooks/useTranslation";
import { makeStyles } from "../../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    count: {
        position: 'absolute',
        left: theme.spacing(3),
        top: '50%',
        transform: 'translate(0, -50%)',
    },
    selectedCount: {
        color: function (_a) {
            var selectedCount = _a.selectedCount, maxCount = _a.maxCount;
            return selectedCount < maxCount ? theme.palette.common.black : theme.palette.error.main;
        },
    },
}); }, { name: 'SnWorkTemplateTab' });
export var SelectedWorks = function (props) {
    var selectedCount = props.selectedCount, maxCount = props.maxCount;
    var classes = useStyles(props);
    var t = useTranslation().t;
    return (React.createElement(Typography, { className: classes.count }, t('選んだワーク') + " ",
        React.createElement("span", { className: classes.selectedCount }, selectedCount), " / " + maxCount));
};
